// Regras de aproximação (palavra-chave/regex na mensagem recebida): a tela não
// cria mais regra (item 5.7 do levantamento myCar, 2026-09-13). A Origem do
// lead e as automações de entrada fazem o mesmo trabalho melhor. O motor no
// backend continua rodando para quem já tem regra salva.

// Quantas regras vieram salvas no config carregado do funil ou da etapa.
export const contarRegrasSalvas = (cfg) => (
  Array.isArray(cfg && cfg.rules) ? cfg.rules.length : 0
);

// A seção só aparece quando havia regra salva ao abrir o painel. Remover as
// regras na tela não esconde a seção antes de salvar: o aviso de "salve para
// confirmar" precisa continuar visível.
export const mostrarRegrasAntigas = (savedCount) => Number(savedCount) > 0;
